import apiService from '../../services/api'

export default {
	namespaced: true,
	state: {
		place: false,
		formattedPlace: false,
		fibreProviders: [],
		fixedWirelessProviders: [],
		selectedFibreProvider: false
	},
	getters: {
		place: state => {
			return state.place;
		},
		formattedPlace: state => {
			return state.formattedPlace;
		},
		availableFibreProviders: state => {
			return state.fibreProviders;
		},
		fixedWirelessProviders: state => {
			return state.fixedWirelessProviders;
		},
		selectedFibreProvider: state => {
			return state.selectedFibreProvider;
		},
	},
	mutations: {
		updatePlace(state, place) {
			state.place = place;
		},
		updateFormattedPlace(state, formattedPlace) {
			state.formattedPlace = formattedPlace;
		},
		updateFibreProviders(state, fibreProviders) {
			state.fibreProviders = fibreProviders;
		},
		updateFixedWirelessProviders(state, fixedWirelessProviders) {
			state.fixedWirelessProviders = fixedWirelessProviders;
		},
		setFibreProvider(state, provider) {
			state.selectedFibreProvider = provider;
		},
	},
	actions: {

		checkCoverageOldApi({commit}, request) {
			return new Promise((resolve, reject) => {
				return apiService.post('https://clientzone.afrihost.com/en/api/of/format-place', request)
					.then(response => {
						commit('updateFormattedPlace', response.place);
						return apiService.post('https://clientzone.afrihost.com/en/api/of/fibre-location-products', response)
							.then(response => {
								resolve(response);
							}, error => {
								reject(error);
							});
					}, error => {
						reject(error);
					});
			});
		},

		getFormattedAddress({commit}, request) {
			return new Promise((resolve, reject) => {
				return apiService.post('https://clientzone.afrihost.com/en/api/of/format-place', request)
					.then(response => {
						commit('updateFormattedPlace', response.place);
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},

		checkCoverage({commit}, request) {
			return new Promise((resolve, reject) => {
				return apiService.get('https://clientzone.afrihost.com/en/api/public/v1/coverage/vendors', request)
					.then(response => {
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},

		showInterest({commit, state}, request) {
			return new Promise((resolve, reject) => {

				return apiService.post('https://clientzone.afrihost.com/en/api/of/fibre-show-interest', {
						place: state.formattedPlace,
						user: request.user
					})
					.then(response => {
						resolve(response);
					}, error => {
						reject(error);
					});
			});
		},

	}
}
